/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useState, useContext, useCallback, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import { MLPolicyTypeUtil } from 'ml-portals-util-react';
import MLEditableCoveragesComponent from '../MLEditableCoveragesComponent/MLEditableCoveragesComponent';
import MLReadOnlyCoverageComponent from '../MLReadOnlyCoverageComponent/MLReadOnlyCoverageComponent';
import MLHOConditionsCoverageComponent from '../MLHOConditionsCoverageComponent/MLHOConditionsCoverageComponent';
import MLHOEditScheduledPropertyComponent from '../MLHOEditScheduledPropertyComponent/MLHOEditScheduledPropertyComponent';
import MLHOEditMineSubSchedItemComponent from '../MLMineSubSchedItems/MLHOEditMineSubSchedItemComponent';
import '@xengage/gw-platform-translations';
import metadata from './MLHOEditCoveragesComponent.metadata.json5';
import styles from './MLHOEditCoveragesComponent.module.scss';
import messages from './MLHOEditCoveragesComponent.messages';

import { IntlContext } from '@jutro/legacy/locale';

const VPP_DTO = 'metlife.edge.capabilities.quote.submission.lob.homeowners.dto.ValuablePersonalPropertyDTOML';
const SPP_DTO = 'metlife.edge.capabilities.quote.submission.lob.homeowners.dto.ScheduledPersonalPropertyDTOML';
const MINE_SUB_SCHED_ITEM_DTO = 'metlife.edge.capabilities.quote.submission.lob.homeowners.dto.MineSubsidenceScheduledItemDTO';

function MLHOEditCoveragesComponent(props) {
    const {
        model,
        loading,
        onCovChange,
        onGeneralChange,
        isDisplayOnly,
        replacementCostMsg,
        editCoverage,
        showEditCoverage,
        isAgent,
        isQuoteStale,
        filterData,
        isEndorsement,
        itemizedFees,
        totalFees,
        isOccupancySecondaryOrSeasonal,
        isModernProduct,
        isNotDwellingPolicy,
        isLLPolicy,
        endorsementVM,
        submissionVM
    } = props;

    const translator = useTranslator();
    const intl = useContext(IntlContext);

    const isQnB = appConfig.portalCode === 'QB';
    const isAMP = appConfig.portalCode === 'AMP';

    const { getPolicyTypeName } = MLPolicyTypeUtil();
    const baseCoverages = _.get(model, 'baseCoverages', []);
    const optionalCoverages = _.get(model, 'optionalCoverages_ML', []);
    const exclusionCoverages = _.get(model, 'exclusionCoverages_ML', []);
    const additionalCoverages = _.get(model, 'additionalCoverages', []);
    const conditionCoverages = _.get(model, 'conditionCoverages_ML', []);
    const valuablePersonalProperties = _.get(model, 'valuablePersonalProperties_ML', []);
    const schedulePersonalProperties = _.get(model, 'schedulePersonalProperties_ML', []);
    const defaultMineSubSchedItems = _.get(model, 'mineSubsidenceScheduledPvtStructureItem', []);
    const defaultVpp = _.get(model, 'defaultValuablePersonalProperty_ML', {});
    const defaultSpp = _.get(model, 'defaultSchedulePersonalProperty_ML', {});
    const defaultMineSubSchedItem = _.get(model, 'defaultMineSubsidenceScheduledPvtStructureItem', {});

    const [isValuablePersonalPropertySelected, setIsValuablePersonalPropertySelected] = useState(valuablePersonalProperties.length > 0);
    const [isScheduledPersonalPropertySelected, setIsScheduledPersonalPropertySelected] = useState(schedulePersonalProperties.length > 0);
    const [isMineSubSchedItemSelected, setIsMineSubSchedItemSelected] = useState(defaultMineSubSchedItems.length > 0);
    const [isMineSubSchedItemAvailable, setIsMineSubSchedItemAvailable] = useState(false);
    const isValuablePersonalPropertyAvailable = optionalCoverages.some((opt) => opt.code_ML === 'HOPValuablePersonalProperty');
    const isScheduledPersonalPropertyAvailable = optionalCoverages.some((opt) => opt.code_ML === 'HOPScheduledPersonalProperty');
    const selectedExclusions = exclusionCoverages.filter((exclusion) => exclusion.selected);


    const updateScheduledPersonalProperty = () => {
        setIsScheduledPersonalPropertySelected(!isScheduledPersonalPropertySelected);
    };

    const updateValuablePersonalProperty = () => {
        setIsValuablePersonalPropertySelected(!isValuablePersonalPropertySelected);
    };

    const updateMineSubSchedItem = () => {
        setIsMineSubSchedItemSelected(!isMineSubSchedItemSelected);
    };

    const resolvers = {
        resolveCallbackMap: {
            onEditCoverage: editCoverage
        },
        resolveComponentMap: {
            mleditablecoveragescomponent: MLEditableCoveragesComponent,
            mlreadonlycoveragecomponent: MLReadOnlyCoverageComponent,
            mlhoconditionscoveragecomponent: MLHOConditionsCoverageComponent,
            mlhoeditscheduledpropertycomponent: MLHOEditScheduledPropertyComponent,
            mlhoEditMineSubSchedItemComponent: MLHOEditMineSubSchedItemComponent
        },
        resolveClassNameMap: styles
    };

    const getPolicyTypeMessage = useCallback(() => {
        const covCode = _.get(model, 'coveragePartType_ML', 'hopdwelling');
        const policyTypeUpperCase = getPolicyTypeName(covCode);
        const policyType = policyTypeUpperCase.toLowerCase();
        const message = translator(messages.policyTypeMsg, { policyType });
        return message;
    }, [getPolicyTypeName, model, translator]);

    const formatAmountString = (amount) => {
        try {
            return intl.formatNumber(amount.amount, { style: 'currency', currency: amount.currency });
        } catch (e) {
            return '';
        }
    };

    const generateCondCovsOverrides = () => {
        const overrides = conditionCoverages.map((cond, index) => {
            return {
                [`condCovsComponent${index}`]: {
                    model: cond,
                    index
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    useEffect(() => {
        const isMineSubAvailable = _.get(model, 'isMineSubsidenceItemVisible', false)
        if (isMineSubAvailable) {
            setIsMineSubSchedItemAvailable(true);
        }
        else {
            setIsMineSubSchedItemAvailable(false);
        }
    }, [])

    const checkvisibilty = () => {
        let visible = true;
        if(isModernProduct && isLLPolicy) {
            visible = false;
        }
        else if(isModernProduct && !isEndorsement && !_.isUndefined(submissionVM)) {
            const isDwellingUnderConstruction = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.underconstructionDwelling.value', undefined);
            const isPersonalLoss = _.get(submissionVM, 'lobData.homeowners.coverables.constructionDetails_ML.includeForPPandLossOfUse.value', undefined);
            if(!_.isUndefined(isDwellingUnderConstruction) && !_.isUndefined(isPersonalLoss) && isDwellingUnderConstruction === true && isPersonalLoss === false) {
                visible = false;
            }
        }
        else if (isModernProduct && isEndorsement && !_.isUndefined(endorsementVM)) {
            const isDwellingUnderConstruction = _.get(endorsementVM, 'lobData.homeowners.coverables.constructionDetails_ML.underconstructionDwelling.value', undefined);
            const isPersonalLoss = _.get(endorsementVM, 'lobData.homeowners.coverables.constructionDetails_ML.includeForPPandLossOfUse.value', undefined);
            if(!_.isUndefined(isDwellingUnderConstruction) && !_.isUndefined(isPersonalLoss) && isDwellingUnderConstruction === true && isPersonalLoss === false) {
                visible = false;
            }
        }
        return visible;
    }

    const overrides = {
        editCovsCol12: {
            className: isAgent ? 'col-md-12' : 'col-md-12 vertical-spacing-40'
        },
        covHeader: {
            className: _.isUndefined(replacementCostMsg) ? 'ml-ho-coverages section-header vertical-spacing-20' : 'ml-ho-coverages section-header vertical-spacing-10'
        },
        replacementCostP: {
            visible: !_.isUndefined(replacementCostMsg) && isAMP
        },
        hoReplacementCostHeaderMsg: {
            content: _.get(replacementCostMsg, 'message', '')
        },
        replacementCostMsgTooltip: {
            tooltipContent: _.get(replacementCostMsg, 'help', ''),
            noHeader: true
        },
        policyTypeMsg: {
            content: getPolicyTypeMessage(),
            visible: !isAgent && isDisplayOnly
        },
        agentCovTableHeader: {
            visible: isAgent
        },
        editableBaseCoverages: {
            visible: !isDisplayOnly,
            coverages: baseCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent,
            isOccupancySecondaryOrSeasonal,
            isModernProduct
        },
        readOnlyBaseCoverages: {
            visible: isDisplayOnly,
            coverages: baseCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent,
            isOccupancySecondaryOrSeasonal,
            isModernProduct
        },
        mineSubSchedItemContainer: {
            className: isQnB ? 'clearfix col-md-12 mineContainerSpacing' : 'clearfix col-md-12'
        },
        agentBaseCoveragesTotals: {
            visible: isAgent
        },
        agentBasePremiumVal: {
            className: isQuoteStale() ? 'strikethrough' : ''
        },
        sectionHeaderSpanValue: {
            content: formatAmountString(_.get(model, 'fullTermCost_Ext'))
        },
        stateFeesBasePremium: {
            visible: _.get(totalFees, 'amount', 0) > 0,
            totalFees: totalFees,
            itemizedFees: itemizedFees,
            displayAlternativeTemplate: true
        },
        optionalCovsHeaderRow: {
            className: isDisplayOnly ? 'row vertical-spacing-40' : 'row'
        },
        optCovsContaner: {
            visible: !_.isEmpty(optionalCoverages)
        },
        editableOptCoverages: {
            visible: !isDisplayOnly,
            coverages: optionalCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent,
            isOptionalCoverage: true,
            isModernProduct,
            isNotDwellingPolicy
        },
        readOnlyOptCoverages: {
            visible: isDisplayOnly,
            coverages: optionalCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent
        },
        vppParentContainer: {
            visible: isValuablePersonalPropertyAvailable
        },
        vppEditMode: {
            visible: !isDisplayOnly
        },
        vppCheckboxEditMode: {
            label: translator(messages.vpp),
            tooltip: {
                text: _.get(defaultVpp, 'coverageDescription', '')
            },
            onValueChange: updateValuablePersonalProperty,
            value: isValuablePersonalPropertySelected
        },
        mineSubSchedItemCheckboxEditMode: {
            visible: isMineSubSchedItemAvailable,
            label: translator(messages.mineSubSchedItemLabel),
            onValueChange: updateMineSubSchedItem,
            value: isMineSubSchedItemSelected
        },
        vppReadonlyMode: {
            visible: isDisplayOnly && isValuablePersonalPropertySelected
        },
        vppNameTooltipReadonlyMode: {
            tooltipLabel: translator(messages.vpp),
            tooltipContent: _.get(defaultVpp, 'coverageDescription', '')
        },
        vppEditCoverageDiv: {
            visible: showEditCoverage
        },
        vppHoEditSchedPropertyDiv: {
            isVpp: true,
            properties: valuablePersonalProperties,
            defaultValue: defaultVpp,
            dtoPath: VPP_DTO,
            visible: !isDisplayOnly && isValuablePersonalPropertySelected,
            isReadOnly: false,
            onListChange: onCovChange,
            isAgent,
            loading
        },
        mineSubHoEditSchedPropertyDiv: {
            properties: defaultMineSubSchedItems,
            defaultValue: defaultMineSubSchedItem,
            dtoPath: MINE_SUB_SCHED_ITEM_DTO,
            visible: isMineSubSchedItemSelected && isMineSubSchedItemAvailable,
            isReadOnly: false,
            onListChange: onCovChange,
            isAgent,
            loading
        },
        vppHoReadonlySchedPropertyDiv: {
            isVpp: true,
            properties: valuablePersonalProperties,
            defaultValue: defaultVpp,
            dtoPath: VPP_DTO,
            visible: isDisplayOnly && isValuablePersonalPropertySelected,
            isReadOnly: true,
            onListChange: onCovChange,
            isAgent,
            loading
        },

        sppParentContainer: {
            visible: isScheduledPersonalPropertyAvailable
        },
        sppEditMode: {
            visible: !isDisplayOnly
        },
        sppCheckboxEditMode: {
            label: translator(messages.spp),
            tooltip: {
                text: _.get(defaultSpp, 'coverageDescription', '')
            },
            onValueChange: updateScheduledPersonalProperty,
            value: isScheduledPersonalPropertySelected
        },
        sppReadonlyMode: {
            visible: isDisplayOnly && isScheduledPersonalPropertySelected
        },
        sppNameTooltipReadonlyMode: {
            tooltipLabel: translator(messages.spp),
            tooltipContent: _.get(defaultSpp, 'coverageDescription', '')
        },
        sppEditCoverageDiv: {
            visible: showEditCoverage
        },
        sppHoEditSchedPropertyDiv: {
            isVpp: false,
            properties: schedulePersonalProperties,
            defaultValue: defaultSpp,
            dtoPath: SPP_DTO,
            visible: !isDisplayOnly && isScheduledPersonalPropertySelected,
            isReadOnly: false,
            onListChange: onCovChange,
            isAgent,
            loading
        },
        sppHoReadonlySchedPropertyDiv: {
            isVpp: false,
            properties: schedulePersonalProperties,
            defaultValue: defaultSpp,
            dtoPath: SPP_DTO,
            visible: isDisplayOnly && isScheduledPersonalPropertySelected,
            isReadOnly: true,
            onListChange: onCovChange,
            isAgent,
            loading
        },
        exclCovsContainer: {
            visible: !_.isEmpty(exclusionCoverages)
        },
        exclCovsInnerContainer: {
            visible: !isDisplayOnly || (isDisplayOnly && !_.isEmpty(selectedExclusions))
        },
        editableExclCoverages: {
            visible: !isDisplayOnly,
            coverages: exclusionCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent
        },
        readExclOptCoverages: {
            visible: isDisplayOnly,
            coverages: selectedExclusions,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent
        },
        covTotalQnB: {
            visible: isQnB,
        },
        covTotalTooltip: {
            tooltipLabel: translator(messages.covTotal),
            tooltipContent: translator(messages.covTooltip)
        },
        covPremiumDiv: {
            className: isQuoteStale() ? 'col-md-9 text-align-right display-inline-block strikethrough' : 'col-md-9 text-align-right display-inline-block'
        },
        covTotalPrice: {
            content: formatAmountString(_.get(model, 'basePremium'))
        },
        conditionalCoverages: {
            visible: !isEndorsement && checkvisibilty(),
            className: isQnB ? 'row clearfix conditionalCovStyle' : 'row clearfix'
        },
        condCovsIterable: {
            data: conditionCoverages
        },
        specialLimitsBundleContainer: {
            visible: !_.isEmpty(additionalCoverages)
        },
        specialLimitsBundleInnerContainer: {
            visible: !isDisplayOnly || (isDisplayOnly && !_.isEmpty(additionalCoverages))
        },
        editableSpecialLimitsBundle: {
            visible: !isDisplayOnly,
            coverages: additionalCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent,
            isOptionalCoverage: true
        },
        readSpecialLimitsBundle: {
            visible: isDisplayOnly,
            coverages: additionalCoverages,
            loading,
            onCovChange,
            onGeneralChange,
            displayHelpMessage: true,
            editCoverage,
            showEditCoverage,
            filterData,
            isQuoteStale,
            isAgent
        },
        ...generateCondCovsOverrides()
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

MLHOEditCoveragesComponent.propTypes = {
    model: PropTypes.shape({}),
    onCovChange: PropTypes.func,
    loading: PropTypes.bool,
    onGeneralChange: PropTypes.func,
    isDisplayOnly: PropTypes.bool,
    replacementCostMsg: PropTypes.shape({}),
    editCoverage: PropTypes.func,
    showEditCoverage: PropTypes.bool,
    isAgent: PropTypes.bool,
    isQuoteStale: PropTypes.func,
    filterData: PropTypes.func,
    isEndorsement: PropTypes.bool,
    itemizedFees: PropTypes.arrayOf(PropTypes.shape({})),
    totalFees: PropTypes.shape({}),
    isOccupancySecondaryOrSeasonal :PropTypes.bool,
    isModernProduct : PropTypes.bool
};

MLHOEditCoveragesComponent.defaultProps = {
    isAgent: false,
    isEndorsement: false,
    isDisplayOnly: false
};

export default MLHOEditCoveragesComponent;
